import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import {
  AppraisalDetailsForm,
  BorrowerForm,
  PropertyForm,
  PropertyFormCustomLender,
  PropertyFormHeader,
} from './components';
import { isBlank, isNotBlank } from '@roc/feature-utils';

export const SubmitAppraisalForm = observer(({ store }) => {
  const { isValidPropertyType, isDefaultWholesaleLender, isAddressSet } = store;

  const createOrder = () => {
    store.submitAppraisal();
  };

  return (
    <Grid container>
      <Grid container item>
        <Grid item container xs={12} spacing={4}>
          <PropertyFormHeader submitAppraisalStore={store} />
          {isBlank(store.errorMessage) && isAddressSet && (
            <>
              {isDefaultWholesaleLender && (
                <>
                  <PropertyForm submitAppraisalStore={store} />
                  {isValidPropertyType && (
                    <>
                      <AppraisalDetailsForm submitAppraisalStore={store} />
                      <BorrowerForm submitAppraisalStore={store} />
                    </>
                  )}
                </>
              )}
              {!isDefaultWholesaleLender && <PropertyFormCustomLender submitAppraisalStore={store} />
              }
            </>
          )}
          <Grid item container justifyContent="flex-end" spacing={1}>
            {isNotBlank(store.errorMessage) &&
              <Grid item>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  onClick={() => store.resetAddress()}
                  testId="resetAddress"
                >
                  Reset
                </Button>
              </Grid>
            }
            <Grid item>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                onClick={createOrder}
                testId="createOrder"
                disabled={isNotBlank(store.errorMessage)}
              >
                Create Order
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
